import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

const useLazyReadingSkillsQuery = () => {
  return useLazyRestQuery(`${MONOLITH_ORIGIN}/api/v3/standard_category/`);
};

export default useLazyReadingSkillsQuery;
